import { CarMarketState } from '../../views/CarMarket/CarMarket.model';
import { createSlice } from '../wrappers';

interface ICarMarketSlice {
	carMarketState: CarMarketState;
}

const initialState: ICarMarketSlice = {
	carMarketState: CarMarketState.InfoSeller,
};

const carMarketSlice = createSlice({
	name: 'carMarket',
	initialState,
	reducers: {
		setCarMarketState: (state, action) => {
			state.carMarketState = action.payload;
		},
	},
});

export const { setCarMarketState } = carMarketSlice.actions;

export default carMarketSlice.reducer;
